import {
  put,
  call,
  select,
  takeLatest,
  takeEvery } from 'redux-saga/effects';
import {
  ADMIN_USER_FETCH_ALL,
  ADMIN_USER_FETCH,
  ADMIN_USER_ADD,
  ADMIN_USER_UPDATE,
  ADMIN_USER_DELETE
} from './constants';
import {
  fetchUsersSuccess,
  fetchUsersFail,
  fetchUserSuccess,
  fetchUserFail,
  // addUserFail,
  // addUserSucccess,
  updateUserSuccess,
  updateUserFail,
  deleteUserSuccess,
  deleteUserFail,
  markerUserFetching
} from './actions';
import { getCurrentlyFetchingUsers } from './reducer';
import { parseApiError } from '../../util/api';
import UserAdminAPI from './UserAdminAPI';
import { showNotification } from '../../notifications/actions';
import { isValidUser } from './util';

function *fetchUsers () {
  try {
    const { data } = yield call(UserAdminAPI.fetchUsers);
    if (data && Array.isArray(data.users)) {
      yield put(fetchUsersSuccess(data.users));
    } else {
      let msg = 'unexpected response fetching users';
      yield put(fetchUsersFail(msg));
      yield put(showNotification(
        'Failed to load users', msg, 'error', 10
      ));
    }
  } catch (error) {
    const msg = parseApiError(error);
    yield put(fetchUsersFail(msg));
    yield put(showNotification(
      'Failed to load users', msg, 'error', 10
    ));
  }
}

export function *fetchUser (action) {
  try {
    const currentlyFetchingUsers = yield select(getCurrentlyFetchingUsers);
    if (currentlyFetchingUsers[action.userId]) return;
    yield put(markerUserFetching(action.userId));
    const { data } = yield call(UserAdminAPI.fetchUser, action.userId);
    if (data && data.user) {
      yield put(fetchUserSuccess(data.user));
    } else {
      let msg = 'unexpected response fetching user';
      yield put(fetchUserFail(msg, action.userId));
      yield put(showNotification(
        'Failed to load user', msg, 'error', 10
      ));
    }
  } catch (error) {
    const msg = parseApiError(error);
    yield put(fetchUserFail(msg, action.userId));
    yield put(showNotification(
      'Failed to load user', msg, 'error', 10
    ));
  }
}

function *addUser (action) {
  // try {
  //   if (!isValidUser(action.user)) return;
  //   yield call(UserAdminAPI.addUser, action.user);
  //   yield put(addUserSucccess(action.user));
  //   yield put(showNotification(
  //     'Success', `${action.user.name || action.user.email} saved`, 'info', 5
  //   ));
  // } catch (error) {
  //   const msg = parseApiError(error);
  //   yield put(addUserFail(msg, action.user));
  //   yield put(showNotification(
  //     `Failed to add user ${action.user.name || action.user.email} `,
  //     msg,
  //     'error',
  //     10
  //   ));
  // }
}

function *updateUser (action) {
  try {
    if (!isValidUser(action.user)) return;
    yield call(UserAdminAPI.updateUser, action.user);
    yield put(updateUserSuccess(action.user));
    yield put(showNotification(
      'Success', `${action.user.name || action.user.email} saved`, 'info', 5
    ));
  } catch (error) {
    const msg = parseApiError(error);
    yield put(updateUserFail(msg, action.user));
    yield put(showNotification(
      `Failed to update user ${action.user.name || action.user.email}`,
      msg,
      'error',
      10
    ));
  }
}

function *deleteUser (action) {
  try {
    yield call(UserAdminAPI.deleteUser, action.user);
    yield put(deleteUserSuccess(action.user));
    yield put(showNotification(
      'Success', `${action.user.name || action.user.email} deleted`, 'info', 5
    ));
  } catch (error) {
    const msg = parseApiError(error);
    yield put(deleteUserFail(msg, action.user));
    yield put(showNotification(
      `Failed to delete user ${action.user.name || action.user.email}`,
      msg,
      'error',
      10
    ));
  }
}

export default function *adminUserSagas () {
  yield takeLatest(ADMIN_USER_FETCH_ALL, fetchUsers);
  yield takeEvery(ADMIN_USER_FETCH, fetchUser);
  yield takeEvery(ADMIN_USER_ADD, addUser);
  yield takeEvery(ADMIN_USER_UPDATE, updateUser);
  yield takeEvery(ADMIN_USER_DELETE, deleteUser);
}
